import React, { ReactElement, useEffect } from 'react'
import Divider from '../Divider'
import ChatOverview from './ChatOverview'
import { ArtData } from '@/database/art'

const ChatPanel = ({ artData, tabName }: { artData: ArtData | undefined; tabName: string }): ReactElement => {
    useEffect(() => {
        if (artData?.tokenId) {
            window.location.hash = `#nft-${artData?.tokenId + tabName}#comments`
        } else {
            window.location.hash = `#art-${artData?.art.id + tabName}#comments`
        }
    }, [artData])

    return (
        <div className="panel">
            <Divider />
            <ChatOverview artData={artData} />
        </div>
    )
}

export default ChatPanel
